module.exports = __webpack_public_path__ + "img/de.5912b362.png";